'use client'
import DataWithLabel from '@lyra/core/components/DataWithLabel'
import formatUSD from '@lyra/core/utils/formatUSD'
import useSubaccount from '@lyra/web/hooks/useSubaccount'

import MarginUsageDataWithLabel from './MarginUsageProgress'

type Props = {
  isCompact?: boolean
}

const SubaccountSummaryItems = ({ isCompact }: Props) => {
  const { marginUtilization, subaccount, collateralValue, buyingPower } = useSubaccount()

  return (
    <>
      <DataWithLabel
        label="Collateral Value"
        value={formatUSD(collateralValue)}
        isSmall={isCompact}
      />
      {marginUtilization > 0 ? (
        <MarginUsageDataWithLabel marginUtilization={marginUtilization} isSmall={isCompact} />
      ) : null}
      <DataWithLabel label="Buying Power" value={formatUSD(buyingPower)} isSmall={isCompact} />
      <DataWithLabel
        label="Margin Type"
        value={subaccount?.margin_type === 'PM' ? `${subaccount.currency} Portfolio` : 'Standard'}
        isSmall={isCompact}
      />
    </>
  )
}

export default SubaccountSummaryItems
